import { useMemo } from 'react';

export const useStepPosition = ({ playableSteps, activeStep }) => {
  const stepPosition = useMemo(() => {
    return playableSteps?.findIndex(
      (playableStep) => playableStep.stepId === activeStep?.stepId
    );
  }, [activeStep, playableSteps]);

  const isTourFirstStep = stepPosition === 0;
  const isTourLastStep = playableSteps?.length
    ? stepPosition === playableSteps?.length - 1
    : false;

  return { isTourFirstStep, isTourLastStep };
};
